<template>
  <mdb-container
    fluid
    v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }"
  >
    <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold">
      <strong>Dashboard</strong>
    </h2>
    <div
      class="mt-lg-2 mb-1 pb-1"
      style="font-family: OpenSans-Regular; font-size: 12px; color: #1d71b8"
    >
      <p>
        <span style="font-family: OpenSans-bold">¡Hola!</span> Se muestran las
        estadísticas de tu administración
      </p>
      <p>
        <span style="font-size: 14px; font-family: OpenSans-bold">{{
          new Date() | moment("LL")
        }}</span>
      </p>
    </div>

    <!--Section: Analytical panel-->
    <section v-if="isIntegrator" class="mb-5 mt-4">
      <mdb-container>
        <mdb-row>
          <mdb-card-group deck>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-entries"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Total de licencias disponibles
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ licensesTotal }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-exits"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Licencias asignadas
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ licensesUsed }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-visitants"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Licencias dispoibles
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ licenses }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
          </mdb-card-group>
        </mdb-row>
      </mdb-container>
    </section>
    <section v-else class="mb-5 mt-4">
      <mdb-container>
        <mdb-row>
           <mdb-card-group deck>
              <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-licencia"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Total de licencias
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ formatoNumero(assignedLicenses) }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                       <i class="fa icn-asignadas"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Licencias usadas
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ formatoNumero(numberOfHousesWithApp) }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-disponibles"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Licencias restantes
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ formatoNumero(assignedLicenses - numberOfHousesWithApp) }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                       <i class="fa icn-visitants"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px;top: 5px;">
                    <div class="text-left" style="font-size: 13px; color: #1d71b8">
                      Residentes registrados
                      <p style="font-size: 30px; font-family: OpenSans-Bold;">
                        {{ formatoNumero(recordedResident) }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
           </mdb-card-group>
        </mdb-row>
        <mdb-row class="mt-5">
          <mdb-card-group deck>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-entries"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Entradas registradas
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ formatoNumero(contadorEntradas) }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-exits"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Salidas registradas
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ formatoNumero(contadorSalidas) }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-visitants"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px; top: 5px">
                    <div
                      class="text-left"
                      style="font-size: 13px; color: #1d71b8"
                    >
                      Visitantes activos
                      <p style="font-size: 30px; font-family: OpenSans-Bold">
                        {{ formatoNumero(entriesActive) }}
                      </p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
            <!-- <mdb-card cascade>
              <mdb-card-body class="Rectngulo-1394 card-body-dashboard">
                <mdb-row>
                  <mdb-col class="col-5">
                    <div class="Rectngulo-1396">
                      <i class="fa icn-clock"></i>
                    </div>
                  </mdb-col>
                  <mdb-col class="col-7" style="left: -20px;top: 5px;">
                    <div class="text-left" style="font-size: 13px; color: #1d71b8">
                      Con más de 12 hrs
                      <p style="font-size: 30px; font-family: OpenSans-Bold;">{{entries12Hrs}}</p>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card> -->
          </mdb-card-group>
        </mdb-row>
        <mdb-row>
          <mdb-tabs
            :active="0"
            justify
            default
            border
            :links="[
              { text: 'Entradas registradas por día' },
              { text: 'Entradas registradas por mes' },
            ]"
            :transition-duration="0.5"
            transition-style="linear"
            class="tab-style mb-5"
          >
            <template :slot="'Entradas registradas por día'">
              <mdb-card class="card-tab">
                <mdb-card-body>
                  <mdb-row>
                    <mdb-col style="border-right: 2px solid #f6f6f6">
                      <mdb-container>
                        <mdb-line-chart
                          :data="lineChartDataDaily"
                          :options="lineChartOptions"
                          :width="600"
                          :height="300"
                        ></mdb-line-chart>
                      </mdb-container>
                    </mdb-col>
                    <mdb-col style="border-right: 2px solid #f6f6f6">
                      <mdb-row style="margin-top: 2rem">
                        <mdb-col>
                          <span>
                            <img
                              alt="icono grafico"
                              :src="
                                imgServer +
                                'apps/myfrac/admin/assets/Grupo_azul@3x.png'
                              "
                              class="img-fluid"
                              style="
                                width: auto;
                                height: 4rem;
                                margin-left: 2rem;
                              "
                            />
                          </span>
                        </mdb-col>
                        <mdb-col>
                          <span
                            style="
                              font-family: OpenSans-Regular;
                              font-size: 12px;
                              color: #1d71b8;
                            "
                            >Total de visitas con QR</span
                          >
                        </mdb-col>
                        <mdb-col>
                          <div>
                            <span
                              style="
                                font-family: OpenSans-Bold;
                                font-size: 30px;
                                color: #1d71b8;
                              "
                              >{{ formatoNumero(entriesTotalQr) }}</span
                            >
                          </div>
                        </mdb-col>
                      </mdb-row>
                      <mdb-row style="margin-top: 3rem">
                        <mdb-col>
                          <span>
                            <img
                              alt="icono grafico"
                              :src="
                                imgServer +
                                'apps/myfrac/admin/assets/Grupo_verde@3x.png'
                              "
                              class="img-fluid"
                              style="
                                width: auto;
                                height: 4rem;
                                margin-left: 2rem;
                              "
                            />
                          </span>
                        </mdb-col>
                        <mdb-col>
                          <span
                            style="
                              font-family: OpenSans-Regular;
                              font-size: 12px;
                              color: #1d71b8;
                            "
                            >Total de visitas manuales</span
                          >
                        </mdb-col>
                        <mdb-col>
                          <div>
                            <span
                              style="
                                font-family: OpenSans-Bold;
                                font-size: 30px;
                                color: #1d71b8;
                              "
                              >{{ formatoNumero(entriesTotalMn) }}</span
                            >
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </mdb-col>
                  </mdb-row>
                </mdb-card-body>
              </mdb-card>
            </template>
            <template :slot="'Entradas registradas por mes'">
              <mdb-card class="card-tab">
                <mdb-card-body>
                  <mdb-row>
                    <mdb-col style="border-right: 2px solid #f6f6f6">
                      <mdb-container>
                        <mdb-line-chart
                          :data="lineChartData"
                          :options="lineChartOptions"
                          :width="600"
                          :height="300"
                        ></mdb-line-chart>
                      </mdb-container>
                    </mdb-col>
                    <mdb-col>
                      <mdb-row style="margin-top: 2rem;">
                        <mdb-col>
                          <span>
                            <img
                            alt="icono grafico"
                              :src="imgServer+'apps/myfrac/admin/assets/Grupo_azul@3x.png'"
                              class="img-fluid"
                              style="width: auto; height: 4rem; margin-left: 2rem;"
                            />
                          </span>
                        </mdb-col>
                        <mdb-col>
                          <span style="font-family: OpenSans-Regular; font-size: 12px; color: #1d71b8;">Entradas registradas con Qr</span>
                        </mdb-col>
                        <mdb-col>
                          <div>
                            <span
                              style="font-family: OpenSans-Bold; font-size: 30px; color: #1d71b8"
                            >{{ formatoNumero(entriesTotalQr)}}</span>
                          </div>
                        </mdb-col>
                      </mdb-row>
                      <mdb-row style="margin-top: 3rem;">
                        <mdb-col>
                          <span>
                            <img
                            alt="icono grafico"
                              :src="imgServer+'apps/myfrac/admin/assets/Grupo_verde@3x.png'"
                              class="img-fluid"
                              style="width: auto; height: 4rem; margin-left: 2rem;"
                            />
                          </span>
                        </mdb-col>
                        <mdb-col>
                          <span style="font-family: OpenSans-Regular; font-size: 12px; color: #1d71b8;">Entradas registradas sin Qr</span>
                        </mdb-col>
                        <mdb-col>
                          <div>
                            <span
                              style="font-family: OpenSans-Bold; font-size: 30px; color: #1d71b8"
                            >{{ formatoNumero(entriesTotalMn)}}</span>
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </mdb-col>
                  </mdb-row>
                </mdb-card-body>
              </mdb-card>
            </template>
          </mdb-tabs>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- /.Section: data tables -->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Servers from "../../../server.js";
import { mapGetters, mapActions } from "vuex";
import Popup from "./../../core/popup"
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbView,
  mdbIcon,
  mdbBadge,
  mdbSelect,
  mdbDatePicker,
  mdbBarChart,
  mdbDoughnutChart,
  mdbBtn,
  mdbTabs,
  mdbJumbotron,
  mdbMask,
  mdbTextarea,
  mdbInput,
  mdbCarouselItem,
  mdbCarousel,
  mdbLineChart,
} from "mdbvue";

export default {
  name: "Dashboardv2",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbView,
    mdbIcon,
    mdbBadge,
    mdbSelect,
    mdbDatePicker,
    mdbBarChart,
    mdbDoughnutChart,
    mdbBtn,
    mdbTabs,
    mdbJumbotron,
    mdbMask,
    mdbTextarea,
    mdbInput,
    mdbCarouselItem,
    mdbCarousel,
    mdbLineChart,
    Popup
  },
  data() {
    return {
      d:0,
      isIntegrator: false,
      imgServer: Servers.serverImg,
      lineChartOptions: {
        responsive: false,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)",
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)",
              },
            },
          ],
        },
      },
      listV: [],
      licensesTotal: 0,
      licensesUsed: 0,
      licenses: 0,
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      //SOCKET VARIABLES
      isConnected: false,
      socketMessage: "",
      contadorEntradas:0,
      contadorSalidas:0,
    };
  },
  methods: {
      ...mapActions(["checkSession"]),
    formatoNumero(number){
      return new Intl.NumberFormat("en-US").format(number);
    },
    getIntegratorDashboard() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/integrator/dashboard", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      }).then(function (response) {
        aux.licensesTotal = response.data[0];
        aux.licensesUsed = response.data[1];
        aux.licenses = response.data[2];
      });
    },
  },
  async created() {
    await this.checkSession();
    const role = localStorage.getItem("role");
    if (role !== "Integrador") {

      // Ejecutar todas las llamadas en paralelo para mejorar el rendimiento
      await Promise.all([
        this.$store.dispatch("dailyVisits"),
        this.$store.dispatch("monthlyVisits"),
        this.$store.dispatch("EntriesTotalQr"),
        this.$store.dispatch("EntriesTotalManual"),
        this.$store.dispatch("residentSummary")
      ]);

      this.contadorEntradas = this.entries
      this.contadorSalidas = this.exits
      let fecha = new Date();

    this.$socket.emit('subscribe', this.userInfo.testFrac.uuid)
    this.$socket.on('V_IN', data=>{
      this.contadorEntradas++;
      this.lineChartData.datasets[0].data[fecha.getMonth()] = this.lineChartData.datasets[0].data[fecha.getMonth()] + 1
      if(data.accessMode == "MANUAL"){
        this.$store.commit("setEntriesManual", this.barEntriesMn+1)

      }else{
        this.$store.commit("setEntriesQr", this.barEntriesQr+1)

      }
   })

   this.$socket.on('V_OUT', data=>{
        this.contadorSalidas++;
        this.$store.commit("setActive", this.entriesActive-1)
   })
    } else {
      this.isIntegrator = true;
      this.getIntegratorDashboard();
    }
  },
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      chartData: "getLineChart",
      entries: "getEntries",
      exits: "getExits",
      entriesActive: "getActive",
      barEntriesMn: "getEntriesManual",
      barEntriesQr: "getEntriesQr",
      monthlyData: "getMonth",
      entriesTotalQr: "getEntriesTotalQr",
      entriesTotalMn: "getEntriesTotalMn",
      whoami:"getWhoAmi",
      userInfo: "getUserInfo",
      assignedLicenses: "getAssignedLicenses",
      recordedResident: "getRecordedResident",
      recordedUsers: "getRecordedUsers",
      numberOfHouses: "getNumberOfHouses",
      numberOfHousesWithApp: "getNumberOfHousesWithApp"
    }),
    lineChartDataDaily() {
      return {
        labels: ["","Entradas registradas por día",""],
        datasets: [
          {
            label: "Manuales",
            backgroundColor: "rgba(255, 99, 132, 0.1)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 0.7,
            data: [0,this.barEntriesMn,0],
          },
          {
            label: "Qr",
            backgroundColor: "rgba(151,187,205,0.2)",
            borderColor: "rgba(151,187,205,1)",
            borderWidth: 0.8,
            data: [0,this.barEntriesQr,0],
          },
        ],
      };
    },
    
    lineChartData() {
      let data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (let index in this.monthlyData) {
        data[this.monthlyData[index].month-1] = this.monthlyData[index].total;
      }

      return {
        labels: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        datasets: [
          {
            label: "Entradas registradas por mes",
            backgroundColor: "rgba(255, 99, 132, 0.1)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 0.7,
            data: data,
          },
        ],
      };
    },
  },
};
</script>

<!-- Add 'scoped" attribute to limit CSS to this component only -->
<style>
.Rectngulo-1396 {
  width: 83.5px;
  height: 99px;
  background-color: #a9bcce;
}

.Rectngulo-1394 {
  width: 258.5px;
  height: 99px;
  box-shadow: 0 10px 12px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}

.card-body-dashboard {
  padding: 0 !important;
}

.icn-entries {
  width: 50px !important;
  height: 50px !important;
  background-image: url("https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Auto_icon@3x.png") !important;
  background-size: 50px 50px !important;
  margin-top: 20px;
  margin-left: 15px;
}
.icn-exits {
  width: 50px !important;
  height: 50px !important;
  background-image: url("https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Salidas_icon@3x.png") !important;
  background-size: 50px 50px !important;
  margin-top: 20px;
  margin-left: 15px;
}

.icn-visitants {
  width: 50px !important;
  height: 50px !important;
  background-image: url("https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Visitante_icon@3x.png") !important;
  background-size: 50px 50px !important;
  margin-top: 20px;
  margin-left: 15px;
}

.icn-clock {
  width: 50px !important;
  height: 50px !important;
  background-image: url("https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Tiempo@3x.png") !important;
  background-size: 50px 50px !important;
  margin-top: 20px;
  margin-left: 15px;
}

.icn-asignadas {
  width: 50px !important;
  height: 50px !important;
  background-image: url("../../../static/icons/Asginadas_icon.svg") !important;
  background-size: 50px 50px !important;
  margin-top: 20px;
  margin-left: 15px;
}

.icn-disponibles{
  width: 50px !important;
  height: 50px !important;
  background-image: url("../../../static/icons/Disponible_icon.svg") !important;
  background-size: 50px 50px !important;
  margin-top: 20px;
  margin-left: 15px;

}

.icn-licencia {
  width: 50px !important;
  height: 50px !important;
  background-image: url("../../../static/icons/Licencia_icon.svg") !important;
  background-size: 50px 50px !important;
  margin-top: 20px;
  margin-left: 15px;
}

.tab-style {
  margin-top: 5rem !important;
}

.card-tab {
  margin-left: -1rem !important;
  margin-right: -1rem !important;
  margin-top: -2rem !important;
  padding-bottom: 0rem;
  padding-top: 1rem;
  width: 109%;
}
</style>
